module.exports = __webpack_public_path__ + "img/bien_etre_animal.a3ebe81f.png";